/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconOffice extends React.Component {
  render() {
    const iconClasses = classNames("icon office", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path
          d="M 9 3 A 1.0001 1.0001 0 1 0 9 5 L 21 5 A 1.0001 1.0001 0 1 0 21 3 L 9 3 z M 6 7 A 1.0001 1.0001 0 1 0 6 9 L 6 27 L 12 27 L 12 22 L 13 22 L 13 20 L 12 20 L 12 16 C 12 14.343 13.343 13 15 13 L 24 13 L 24 9 A 1.0001 1.0001 0 1 0 24 7 L 6 7 z M 8 10 L 10 10 L 10 12 L 8 12 L 8 10 z M 12 10 L 14 10 L 14 12 L 12 12 L 12 10 z M 16 10 L 18 10 L 18 12 L 16 12 L 16 10 z M 20 10 L 22 10 L 22 12 L 20 12 L 20 10 z M 8 14 L 10 14 L 10 16 L 8 16 L 8 14 z M 15 15 A 1.0001 1.0001 0 1 0 15 17 L 15 30 L 21 30 L 21 26 L 23 26 L 23 30 L 29 30 L 29 17 A 1.0001 1.0001 0 1 0 29 15 L 15 15 z M 8 18 L 10 18 L 10 20 L 8 20 L 8 18 z M 17 18 L 19 18 L 19 20 L 17 20 L 17 18 z M 21 18 L 23 18 L 23 20 L 21 20 L 21 18 z M 25 18 L 27 18 L 27 20 L 25 20 L 25 18 z M 8 22 L 10 22 L 10 24 L 8 24 L 8 22 z M 17 22 L 19 22 L 19 24 L 17 24 L 17 22 z M 21 22 L 23 22 L 23 24 L 21 24 L 21 22 z M 25 22 L 27 22 L 27 24 L 25 24 L 25 22 z M 17 26 L 19 26 L 19 28 L 17 28 L 17 26 z M 25 26 L 27 26 L 27 28 L 25 28 L 25 26 z"
          style={{
            lineHeight: "normal",
            textIndent: 0,
            textAlign: "start",
            textDecorationLine: "none",
            textDecorationStyle: "solid",
            textDecorationColor: "#000",
            textTransform: "none",
            blockProgression: "tb",
            isolation: "auto",
            mixBlendMode: "normal",
            fontWeight: 400,
            fontFamily: "sans-serif",
            whiteSpace: "normal",
            overflow: "visible"
          }}
        />
      </svg>
    );
  }
}

IconOffice.defaultProps = {
  className: null
};

IconOffice.propTypes = {
  className: PropTypes.string
};

export default IconOffice;
